import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="burger-menu"
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Optional: Close menu when clicking outside
    document.addEventListener('click', this.closeOnOutsideClick.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutsideClick.bind(this))
  }

  toggle() {
    const mobileMenu = document.getElementById('mobile-menu')
    const isHidden = mobileMenu.classList.contains('hidden')

    if (isHidden) {
      mobileMenu.classList.remove('hidden')
      // Add smooth transition
      mobileMenu.classList.add('animate-fade-in')
    } else {
      mobileMenu.classList.add('hidden')
      mobileMenu.classList.remove('animate-fade-in')
    }
  }

  closeOnOutsideClick(event) {
    const mobileMenu = document.getElementById('mobile-menu')
    const burgerButton = document.getElementById('burger-menu-btn')

    if (!mobileMenu.classList.contains('hidden') &&
      !mobileMenu.contains(event.target) &&
      !burgerButton.contains(event.target)) {
      this.toggle()
    }
  }
}
